import { useEffect, useRef } from 'react'
declare global { interface Window { JsBarcode?: any } }

export default function Barcode({
  value, format='CODE128', height=40, displayValue=true, className=''
}:{
  value: string; format?: string; height?: number; displayValue?: boolean; className?: string
}){
  const ref = useRef<SVGSVGElement>(null)
  useEffect(()=>{
    if (window.JsBarcode && ref.current && value) {
      try {
        window.JsBarcode(ref.current, value, { format, height, displayValue, margin: 0 })
      } catch {}
    }
  }, [value, format, height, displayValue])
  return <svg ref={ref} className={className} />
}
